export default __webpack_public_path__ + "static/media/txt.ed52e222.png";